export const STORE_LOCATION = 'STORE_LOCATION';
export const STORE_COMMON = 'STORE_COMMON';
export const STORE_CARD_VIEW = 'STORE_CARD_VIEW';
export const STORE_CART = 'STORE_CART';
